module.exports = __webpack_public_path__ + "static/media/3.c0b2e1df.svg";